import BotAnswerWithButtonsMixin from '@/mixins/bot-answer-with-buttons';
import { Component } from 'vue-property-decorator';

@Component
export default class BotImageMessage extends BotAnswerWithButtonsMixin {}
